<script>
    import * as animateScroll from "svelte-scrollto";
    import { onMount } from 'svelte';
    import Icon from 'fa-svelte';
    import { faSortUp } from '@fortawesome/free-solid-svg-icons/faSortUp';
    import { faSortDown } from '@fortawesome/free-solid-svg-icons/faSortDown';
    import CVSTable from '../table.svelte';

    import data  from "../../data/tabla-requerimientos";

    window.$(document).ready( function () {

    animateScroll.scrollToTop();

    var tableCols = Headers(data);
    var dataSet = Body(data, tableCols);
    
    function Headers(list) { 

        var columns = [];
        var row = list[0]

        for (var line in row) {

            columns.push({title: line});
            
        }
        return columns; 
    }

    function Body(list, header){

        var body = [];
        var bodyRow = [];
        
        for (let i = 0; i < list.length; i++) {
            for (var colIndex = 0; colIndex < header.length; colIndex++){
                bodyRow.push(list[i][header[colIndex]['title']]);
            }
            body.push(bodyRow);
            bodyRow = [];
        }

        return body;
    }
    
    var table = window.$('#dataTable').DataTable({
        responsive: true,
        dom: 't',
        pageLength: dataSet.length,
        data: dataSet,
        footerCallback: function(tfoot, data, start, end, display) {
            var api = this.api();
            var lastRow = api.rows().count();
            for (var i = 0; i < api.columns().count(); i++) {
                window.$(tfoot).find('th').eq(i).html(api.cell(lastRow-1,i).data());
            }
        },
        rowCallback: function( row, data, index ) {            
            if (data[0] == "Recuento") {
                window.$(row).hide();
            }
        },
        columns: tableCols,
        language: {
            "sProcessing":     "Procesando...",
            "sLengthMenu":     "Mostrar _MENU_ registros",
            "sZeroRecords":    "No se encontraron resultados",
            "sEmptyTable":     "Ningún dato disponible en esta tabla",
            "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
            "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
            "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
            "sInfoPostFix":    "",
            "sSearch":         "Buscar:",
            "sUrl":            "",
            "sInfoThousands":  ",",
            "sLoadingRecords": "Cargando...",
            "oPaginate": {
                "sFirst":    "Primero",
                "sLast":     "Último",
                "sNext":     "Siguiente",
                "sPrevious": "Anterior"
            },
            "oAria": {
                "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
                "sSortDescending": ": Activar para ordenar la columna de manera descendente"
            },
            "buttons": {
                "copy": "Copiar",
                "colvis": "Visibilidad"
            }
        }
    });
    /*     MergeGridCells()

    function MergeGridCells() {
        var dimension_cells = new Array();
        var dimension_col = null;
        var columnCount = window.$("#dataTable tr:first th").length;
        for (dimension_col = 0; dimension_col <= 1; dimension_col++) {
            // first_instance holds the first instance of identical td
            var first_instance = null;
            var rowspan = 1;
            // iterate through rows
            window.$("#dataTable").find('tr').each(function () {

                // find the td of the correct column (determined by the dimension_col set above)
                var dimension_td = window.$(this).find('td:nth-child(' + dimension_col + ')');

                if (first_instance === null) {
                    // must be the first row
                    first_instance = dimension_td;
                } else if (dimension_td.text() === first_instance.text()) {
                    // the current td is identical to the previous
                    // remove the current td
                // dimension_td.remove();
                    dimension_td.attr('hidden', true);
                    ++rowspan;
                    // increment the rowspan attribute of the first instance
                    first_instance.attr('rowspan', rowspan);
                } else {
                    // this cell is different from the last
                    first_instance = dimension_td;
                    rowspan = 1;
                }
            });
        }
    } */
});

</script>

<div class="row">

    <div class="col-12 white-bg" style="overflow:hidden;min-height: 100vh;">
        <img src="./img/background-A.svg" alt="" class="background-right disabe-img" style="height: 100vh;">
        <div class="row">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix post-info-title" style="text-align-last: center;margin-bottom:5vh;">
                <h2 class="text-content title-content" style="margin: 20px 0 0 0;"> Listado de requerimientos mínimos </h2>
            </div>
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-10 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-1 padding-fix" id="info-table-id">
                <table id="dataTable" class="display nowrap" style="width:100%">
                    <thead>
                    </thead>
                    <tbody>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>x</th>
                            <th>x</th>
                            <th>x</th>
                            <th>x</th>
                            <th>x</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</div>

<style>

#dataTable{
    font-size: 12pt !important;
    font-family: 'DINPro-Regular';
    color: #006937;
}

#dataTable{
    font-size: 12pt !important;
    font-family: 'DINPro-Regular';
    color: #006937;
}

.white-bg{
    background-color: white;
    overflow: hidden;
}

.background-right{
    right: 0;
    position: absolute;
    height: 100%;
    /* max-height: 100vh; */
}

@media (max-width: 1400px){
    .disabe-img {
        display:none;
    }
    .padding-fix{
        padding:0 15px;
    }
}

.background-right{
    right: 0;
    position: absolute;
    height: 100%;
    max-height: 100vh;
}

.padding-fix{
    padding:0 8px;
}

@media (max-width: 1400px){
    .disabe-img {
        display:none;
    }
    .padding-fix{
        padding:0 15px;
    }
}

.white-bg{
    background-color: white;
    overflow: hidden;
}

</style>
